<fieldset>

  <div class="row step-header">
    <div class="col col-100">
      <h3>Schedule your installation</h3>
      <p>Pick a time when you'll be home, and we'll arrive within a 30-minute window.</p>
      <p class="step-error js-dateError">
        <!-- Errors involving past/invalid dates will show up here -->
      </p>
    </div>
  </div>

  <div class="row card-layout no-border text-dark">
    <div class="calendar-container"></div>
  </div>

</fieldset>
